module.exports = __webpack_public_path__ + "static/media/old spw-global-high-quality.9bef9ccb.csv";